module.exports = __webpack_public_path__ + "static/media/undraw_joyride.9da69a10.svg";